import { useNavigate, useParams } from "react-router-dom";
import { AutomobileVehicle } from "./AutomobileVehicle";
import { PageContainer } from "../../../../../../components/container/PageContainer";

export const AutomobileVehiclePage: React.FC = () => {
  const { customerId, customerPolicyId, vehicleNumber } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    vehicleNumber?: number;
  };
  const navigate = useNavigate();

  const handleSave = () => {
    navigate(
      `/automobile-policy/${customerId}/vehicle-tab/${customerPolicyId}?tab=0`
    );
  };

  const handleAdditionalSave = () => {
    navigate(
      `/automobile-policy/${customerId}/vehicle-tab/${customerPolicyId}?tab=0`
    );
  };

  return (
    <PageContainer
            title={
              vehicleNumber
                ? "Edit Vehicle Information"
                : "Create Vehicle Information"
            }
            description="Manage summary ."
          >
      <AutomobileVehicle
        customerId={customerId}
        customerPolicyId={customerPolicyId}
        vehicleNumber={vehicleNumber}
        onVehicleSaveSuccess={handleSave}
        onAdditionalInfoSaveSucces={handleAdditionalSave}
      />
    </PageContainer>
  );
};
